/** Contact channels. {whatsapp} paragraphs only show when the setting exists. */
import { CONSUMER_URL, type InfoDoc } from "../types";

export const contact: InfoDoc = {
  es: {
    title: "Contacto",
    intro: "Estamos para ayudarte con tus pedidos, dudas sobre cartas o cualquier consulta.",
    sections: [
      {
        title: "Escribinos",
        paragraphs: [
          "Email: {email}. Respondemos dentro de las 48 horas hábiles.",
          "WhatsApp: {whatsapp}.",
          "Si tu consulta es por un pedido, incluí el número de pedido (lo encontrás en el email de confirmación y en Mi cuenta).",
        ],
      },
      {
        title: "Antes de escribir",
        paragraphs: ["Muchas respuestas están en el [[/ayuda|centro de ayuda]] y en la [[/guia-de-compra|guía para comprar]]."],
      },
      {
        title: "Arrepentimiento y reclamos",
        paragraphs: [
          "Para cancelar una compra usá el [[/arrepentimiento|botón de arrepentimiento]]: te damos un código de trámite en el momento.",
          `Defensa de las y los consumidores. Para reclamos: ${CONSUMER_URL}.`,
        ],
      },
    ],
  },
  en: {
    title: "Contact",
    intro: "We're here to help with your orders, questions about cards or anything else.",
    sections: [
      {
        title: "Write to us",
        paragraphs: [
          "Email: {email}. We answer within 48 business hours.",
          "WhatsApp: {whatsapp}.",
          "If it's about an order, include the order number (it's in the confirmation email and in My account).",
        ],
      },
      { title: "Before writing", paragraphs: ["Many answers are in the [[/ayuda|help center]] and the [[/guia-de-compra|buying guide]]."] },
      {
        title: "Withdrawal and complaints",
        paragraphs: [
          "To cancel a purchase use the [[/arrepentimiento|withdrawal button]]: you get a request code right away.",
          `Consumer protection (Argentina), complaints: ${CONSUMER_URL}.`,
        ],
      },
    ],
  },
};
